<template>
  <div>
    <AppSidebar v-if="!hideShell" />
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <AppHeader />
      <div class="body flex-grow-1 px-3">
        <CContainer fluid>
          <router-view />
        </CContainer>
      </div>
    </div>
  </div>
</template>
<script>
import { CContainer } from '@coreui/vue'
import AppHeader from '@/components/site_blocks/AppHeader.vue'
import AppSidebar from '@/components/site_blocks/AppSidebar.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppHeader,
    AppSidebar,
    CContainer,
  },
  computed: {
    hideShell() {
      return this.$route.matched.some((record) => record.meta.hideShell)
    },
  },
}
</script>
